import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Dashboard = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="dashboard-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.59375 2.71777C3.55822 2.71777 2.71875 3.55724 2.71875 4.59277V12.0928C2.71875 13.1283 3.55822 13.9678 4.59375 13.9678H9.59375C10.6293 13.9678 11.4688 13.1283 11.4688 12.0928V4.59277C11.4688 3.55724 10.6293 2.71777 9.59375 2.71777H4.59375ZM4.46875 4.59277C4.46875 4.52374 4.52471 4.46777 4.59375 4.46777H9.59375C9.66279 4.46777 9.71875 4.52374 9.71875 4.59277V12.0928C9.71875 12.1618 9.66279 12.2178 9.59375 12.2178H4.59375C4.52471 12.2178 4.46875 12.1618 4.46875 12.0928V4.59277Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4056 10.0328C13.3701 10.0328 12.5306 10.8723 12.5306 11.9078V19.4078C12.5306 20.4434 13.3701 21.2828 14.4056 21.2828H19.4056C20.4412 21.2828 21.2806 20.4434 21.2806 19.4078V11.9078C21.2806 10.8723 20.4412 10.0328 19.4056 10.0328H14.4056ZM14.2806 11.9078C14.2806 11.8388 14.3366 11.7828 14.4056 11.7828H19.4056C19.4747 11.7828 19.5306 11.8388 19.5306 11.9078V19.4078C19.5306 19.4769 19.4747 19.5328 19.4056 19.5328H14.4056C14.3366 19.5328 14.2806 19.4769 14.2806 19.4078V11.9078Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2806 4.59277C12.2806 3.55724 13.1201 2.71777 14.1556 2.71777H19.4056C20.4412 2.71777 21.2806 3.55724 21.2806 4.59277V7.34277C21.2806 8.37831 20.4412 9.21777 19.4056 9.21777H14.1556C13.1201 9.21777 12.2806 8.37831 12.2806 7.34277V4.59277ZM14.1556 4.46777C14.0866 4.46777 14.0306 4.52374 14.0306 4.59277V7.34277C14.0306 7.41181 14.0866 7.46777 14.1556 7.46777H19.4056C19.4747 7.46777 19.5306 7.41181 19.5306 7.34277V4.59277C19.5306 4.52374 19.4747 4.46777 19.4056 4.46777H14.1556Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.59375 14.7828C3.55822 14.7828 2.71875 15.6223 2.71875 16.6578V19.4078C2.71875 20.4434 3.55822 21.2828 4.59375 21.2828H9.84375C10.8793 21.2828 11.7188 20.4434 11.7188 19.4078V16.6578C11.7188 15.6223 10.8793 14.7828 9.84375 14.7828H4.59375ZM4.46875 16.6578C4.46875 16.5888 4.52471 16.5328 4.59375 16.5328H9.84375C9.91279 16.5328 9.96875 16.5888 9.96875 16.6578V19.4078C9.96875 19.4769 9.91279 19.5328 9.84375 19.5328H4.59375C4.52471 19.5328 4.46875 19.4769 4.46875 19.4078V16.6578Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
